window.scrolledToAnchor = false
import "trix"
import "@rails/actiontext"
import "@hotwired/turbo-rails"

import "../assets/stylesheets/application.scss"

import "./setup/handle_network_errors"
import "./setup/mrujs"
import "./setup/cable_ready_operations"
import "./setup/turbo_stream_actions"
import "./setup/nested_modals"
import "./setup/modal_morph_persistence"
import "./setup/stripe"
import "./setup/shoelace"
import "./setup/log_events"
import "./setup/turbo_frame_retry"
import "./setup/avo_boundary"
import "./controllers/"

document.addEventListener('turbo:before-fetch-request', async (event) => {
  event.preventDefault()

  event.detail.fetchOptions.headers["TURBO_FETCH"] = true

  event.detail.resume()
})

